<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-container">
      <div class="modal-header">
        <h6>Esqueci minha senha</h6>
        <i class="bi bi-x-circle close-icon" @click="close" />
      </div>
      <div class="modal-content">
        <p>Informe seu e-mail para receber instruções de redefinição de senha:</p>
        <input
          v-model="email"
          type="email"
          placeholder="Seu e-mail"
          class="form-control mb-2"
        />
        <div v-if="message" class="alert" :class="messageType">
          {{ message }}
        </div>
      </div>
      <div class="modal-footer">
        <template v-if="!message">
          <button class="btn btn-secondary" @click="close">Cancelar</button>
          <button
            class="btn btn-primary"
            :disabled="!email || isLoading"
            @click="submit"
          >
            {{ isLoading ? 'Verificando…' : 'Enviar' }}
          </button>
        </template>
        <template v-else>
          <button class="btn btn-primary" @click="close">Fechar</button>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import api from '@/services/axios';

const props = defineProps({
  visible: Boolean
});
const emit = defineEmits(['close']);

const email = ref('');
const isLoading = ref(false);
const message = ref('');
const messageType = ref('alert-success');

watch(() => props.visible, v => {
  if (v) {
    email.value = '';
    message.value = '';
  }
});

async function submit() {
  if (!email.value) return;
  isLoading.value = true;
  message.value   = '';

  try {
    // 1) Verifica se o e-mail está cadastrado
    message.value     = '';
    const check = await api.get('/auth/check-email', { params: { email: email.value } });
    if (!check.data.exists) {
      messageType.value = 'alert-danger';
      message.value     = 'E-mail não cadastrado.';
      return;
    }
    // 2) Envia instruções de reset
    const res = await api.post('/auth/forgot-password', { email: email.value });
    messageType.value = 'alert-success';
    message.value     = res.data.message;
  } catch (err) {
    messageType.value = 'alert-danger';
    message.value     = err.response?.data?.message || 'Erro ao enviar instruções.';
  } finally {
    isLoading.value = false;
  }
}

function close() {
  emit('close');
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}
.modal-container {
  background: #fff;
  border-radius: 8px;
  width: 100%;
  max-width: 400px;
  overflow: hidden;
}
.modal-header {
  background: #f5f5f5;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.close-icon {
  font-size: 1.2rem;
  cursor: pointer;
}
.modal-content {
  padding: 16px;
}
.modal-footer {
  padding: 12px 16px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  background: #f5f5f5;
}
.alert {
  padding: 8px;
  border-radius: 4px;
  margin-top: 8px;
}
.alert-success { background-color: #d4edda; color: #155724; }
.alert-danger { background-color: #f8d7da; color: #721c24; }
</style>
